import React from "react";
import "./Persona.css"
import {Tooltip} from "../common/Tooltip";

type PersonaButtonProps = {
    className: string;
    tooltip: string;
    leftOffset: number;
    onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const PersonaButton = (props: PersonaButtonProps) => {

    const style = {
        left: props.leftOffset,
    };

    return (
        <Tooltip title={props.tooltip}>
            <div className={props.className}
                 style={style}
                 onClick={props.onClick}/>
        </Tooltip>
    );
}
